module.exports = __webpack_public_path__ + "static/media/top-steps-active-dot.2cbf9f8b.svg";